import { render, staticRenderFns } from "./SimpleSummaryBar.vue?vue&type=template&id=70512fbb&scoped=true"
import script from "./SimpleSummaryBar.vue?vue&type=script&lang=js"
export * from "./SimpleSummaryBar.vue?vue&type=script&lang=js"
import style0 from "./SimpleSummaryBar.vue?vue&type=style&index=0&id=70512fbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70512fbb",
  null
  
)

export default component.exports